import PaymentModel from "./PaymentModel";
import InvoiceLineItemModel from "./InvoiceLineItemModel";
import { InvoiceStatus } from "../Enums/InvoiceStatus";

export default class InvoiceModel {
    invoiceNumber: string;
    invoiceStatus: InvoiceStatus;
    createDate: string;
    total: number;
    balance: number;
    lineItems: Array<InvoiceLineItemModel>;
    appliedPayment: PaymentModel;
    infoUrl: string;
    moduleSelection: string;
    formattedCnpType: string;
    isPaid: boolean;
    isExpanded: boolean;
    amountDue = () => this.lineItems?.reduce((sum, _) => sum + _.unitPrice - _.discountAmount, 0);
    paymentIncludesMultipleInvoices = () => (this.appliedPayment?.amount > this.total);

    constructor(data :
            {
                invoiceNumber?: string;
                invoiceStatus?: InvoiceStatus; 
                createDate?: string;
                total?: number;
                balance?: number; 
                lineItems?: Array<InvoiceLineItemModel>
                appliedPayment?: PaymentModel;
                infoUrl?: string;
                moduleSelection?: string;
                formattedCnpType?: string;
                isPaid?: boolean;
                isExpanded?: boolean;
            }
        ) 
        {
            this.invoiceNumber = data.invoiceNumber;
            this.invoiceStatus = data.invoiceStatus;
            this.createDate = data.createDate;
            this.total = data.total;
            this.balance = data.balance;
            this.appliedPayment = data.appliedPayment;
            this.infoUrl = data.infoUrl;
            this.moduleSelection = data.moduleSelection;
            this.formattedCnpType = data.formattedCnpType;
            this.isPaid = data.isPaid;
            this.isExpanded = data.isExpanded;
            this.lineItems = new Array<InvoiceLineItemModel>();
            
            data.lineItems.forEach(_ => {
                this.lineItems.push(new InvoiceLineItemModel(_.unitPrice, _.amount, _.createdDate, _.description, _.discountAmount, _.discountDescription, _.product, _.isRefunded));
            })
        }
}
